import { IQueryParameters } from 'common/models';
import API from 'services/api';

export const getProperties = ({ params }: IQueryParameters) =>
  API.get('/api/accommodation/properties', {
    params: { ...params },
  }).then(response => response?.data);
